import {get, put} from './http';

export type SubmissionStatusCheckConfig = {
  batch_size: number;
  pre_delivery_interval_hours: number;
  post_delivery_daily_interval_hours: number;
  post_delivery_daily_duration_days: number;
  post_delivery_weekly_interval_days: number;
  post_delivery_cutoff_days: number;
  stop_after_consecutive_removed: number;
  modified_by: string | null;
  modified_at: string | null;
};

export type UpdateSubmissionStatusCheckConfigPayload = {
  batch_size: number;
  pre_delivery_interval_hours: number;
  post_delivery_daily_interval_hours: number;
  post_delivery_daily_duration_days: number;
  post_delivery_weekly_interval_days: number;
  post_delivery_cutoff_days: number;
  stop_after_consecutive_removed: number;
};

export const submissionStatusCheckConfigApi = {
  get: async () => get<SubmissionStatusCheckConfig>('/submission-status-check-config'),
  update: async (payload: UpdateSubmissionStatusCheckConfigPayload) =>
    put<UpdateSubmissionStatusCheckConfigPayload, SubmissionStatusCheckConfig>(
      '/submission-status-check-config',
      payload
    )
};
